import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class ProtectedRoute extends Component {
  render() {
    const { component: Component, isLogin, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={(props) => {
          if (!isLogin) {
            return <Redirect to="/" />;
          } else {
            return <Component {...rest} {...props} />;
          }
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  const { auth } = state;
  return {
    alert,
    isLogin: auth.logInSuccess,
  };
}

export default withRouter(connect(mapStateToProps)(ProtectedRoute));



// WEBPACK FOOTER //
// ./src/Routes/Routes.js